import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, Grid, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import FulltextSearchForm from "../../components/Forms/FulltextSearchForm";
import Loading from "../../components/Loading/index";

class AvatarList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avatars: [],
            removeAvatar: null,
            fulltext: null,
            loading: true,
        };

        this.handleChangeFulltext = this.handleChangeFulltext.bind(this);
        this.handleSubmitFulltext = this.handleSubmitFulltext.bind(this);

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.getAvatars()
    };

    getAvatars(fulltext) {
        this.setState({
                loading: true
            }
        );
        axios.get(this.props.api.avatars, {
            params: {
                q: fulltext
            }}
        ).then((result) => {
            this.setState({
                avatars: result.data,
                loading: false
            });
        }).catch((error) => {
            console.error('Axios error: ', error);
        });
    }

    handleChangeFulltext(event) {
        this.setState({
            fulltext: event.target.value
        });
    }

    handleSubmitFulltext(event) {
        event.preventDefault();
        this.getAvatars(this.state.fulltext);
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeAvatar: null
        })
    }

    showModal(avatar) {
        this.setState({
            showModal: true,
            removeAvatar: avatar
        })
    }

    render() {
        let {avatars, removeAvatar} = this.state;
        let {size} = this.props;

        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );

        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );

        let content;

        if (this.state.loading) {
            content = <Loading message="Načítám avatary..."/>
        } else {
            content = avatars.length > 0 ?
                <Grid>
                    {[...avatars].map((avatar, index) => {
                            let url = `${__APIURL__}/${avatar.filePath}`;
                            return (
                                <div className="avatar-block" key={index}>
                                    <img alt={"avatar " + index}
                                         src={url}
                                         className="avatar"
                                         height={size.height}
                                         width={size.width}
                                    />
                                    <div className="menu-bar">
                                        <OverlayTrigger placement="top" overlay={tooltipEdit}>
                                            <Link to={`/avatars/edit/${avatar.id}`}>
                                                <FontAwesome name="pencil-square-o" />
                                            </Link>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={tooltipRemove}>
                                            <FontAwesome name="trash"
                                                         onClick={() => this.showModal(avatar)}/>
                                        </OverlayTrigger>
                                    </div>
                                    <div className="name" style={{width: size.width}}>
                                        {avatar.name}
                                    </div>
                                </div>
                            )
                        }
                    )}
                </Grid>
                : <p>Nenalezeni žádní avataři.</p>
        }

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam avatarů</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/avatars/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="filter">
                        <FulltextSearchForm
                            label="Vyhledat podle názvu:"
                            placeholder="Zadejte název"
                            handleChange={this.handleChangeFulltext}
                            handleSubmit={this.handleSubmitFulltext}
                        />
                    </div>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {content}
                </div>
                {
                    removeAvatar &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění avatara</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit avatara: {removeAvatar.name}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveAvatar(removeAvatar)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(AvatarList);



/** WEBPACK FOOTER **
 ** ./src/containers/Avatars/AvatarList.js
 **/